<template>
    <div>
        <div class="mb-4 d-flex align-items-center justify-content-between">
            <div>
                <label for="search" class="sr-only">Search</label>
                <input
                    name="search"
                    id="search"
                    type="text"
                    class="form-control"
                    placeholder="Search"
                    v-model="search">
            </div>
            <button type="button"
                    class="btn btn-success"
                    :class="{ 'disabled': state.loading }"
                    :disabled="state.loading"
                    @click="refresh">
                <i class="fas fa-sync mr-1" v-if="!state.loading"></i>
                <i class="fas fa-spinner fa-spin mr-1" v-if="state.loading"></i>
                <span v-if="!state.loading">Refresh</span>
                <span v-if="state.loading">Refreshing</span>
            </button>
        </div>

        <spinner v-if="state.loading"></spinner>

        <div class="table-responsive">
            <table class="table table-striped table-hover" v-if="!state.loading && filteredProcesses.length">
                <thead>
                    <tr>
                        <th>User</th>
                        <th>PID</th>
                        <th>CPU</th>
                        <th>Memory</th>
                        <th>Stat</th>
                        <th>Start</th>
                        <th>Time</th>
                        <th>Command</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="process in filteredProcesses">
                        <td>{{ process.user }}</td>
                        <td>{{ process.pid }}</td>
                        <td>{{ process.cpu }}</td>
                        <td>{{ process.mem }}</td>
                        <td>{{ process.stat }}</td>
                        <td>{{ process.start }}</td>
                        <td>{{ process.time }}</td>
                        <td>
                            <span class="d-inline-block text-truncate" style="max-width: 400px;">
                                {{ process.command }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <h4 class="text-center py-5 border text-muted" v-if="!state.loading && !filteredProcesses.length">
            No processes found.
        </h4>
    </div>
</template>

<script>
export default {
    data() {
        return {
            processes: [],
            state: {
                loading: false,
            },
            search: '',
        };
    },

    computed: {
        filteredProcesses() {
            if (this.search === '') {
                return this.processes;
            } else {
                return this.processes.filter((process) => {
                    return this.search.toLowerCase().split(' ')
                        .every(p => process.command.toLowerCase().includes(p));
                });
            }
        }
    },

    methods: {
        fetch(withLoader = false) {
            if (withLoader) {
                this.state.loading = true;
            }
            return axios.get('/api/system/processes').then(response => {
                this.processes = response.data;
                this.state.loading = false;
            }).catch(() => {
                this.state.loading = false;
            });
        },
        refresh() {
            this.fetch(true);
        }
    },

    mounted() {
        this.fetch(true);
    }
}
</script>
